import styled from 'styled-components';



function Desserts({className=""}) {
  return (
    <DIV className={`${className}`}>
            Desserts
    </DIV>
  );
}


const DIV=styled.div`
    width: 100%;

 
`;

export default Desserts;
